<div class="header-top-menu">
  <div class="d-flex flex-row side--menu">
    <div
      *ngFor="let menu of navMenuItems"
      class="d-flex flex-row align-items-center side--menu-item p-2 cursor-pointer"
      [ngClass]="selectedClass(menu)"
      (click)="onClickTopMenu(menu)"
    >
      <span
        class="icon"
        [ngClass]="'icon--' + menu + ' ' + selectedClass(menu)"
      ></span>

      <span [ngClass]="fontClass(menu)">
        {{ label(menu) }}
      </span>

      <div *ngIf="is(menu)" class="active--dot"></div>
    </div>
  </div>
</div>
